<div>
  <div class="row breadcrumb-wrapper" *ngIf="showBreadCrumb">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="container">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <app-breadcrumb [data]="breadcrumbdata"></app-breadcrumb>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>
<div id="bannerCarousel" class="bannerCarousel">
  <ng-container *ngIf="imageUrls?.length == 0; else loadingContent">
      <div *ngFor="let item of skeletonService.generateFake(1);let i = index;">
          <ngx-skeleton height="570px"></ngx-skeleton>
      </div>
  </ng-container>
  <img  [src]='environment1 + "assets/images/Square-T-skyblue.png"' class="t-image" alt="T">

  <div class="horizontal-line"></div>

  <div class="vertical-line"></div>

  <div class="bottom-horizontal-line"></div>

  <div class="bottom-vertical-line"></div>

  <ng-template #loadingContent>
    <div class="banner-container">
      <owl-carousel-o [options]="customOptionsForBanner">
          <ng-container *ngFor="let data of imageUrls">
              <ng-template carouselSlide [id]="data?.id">
                  <a (click)="GetTest(data)"
                      [ngStyle]="{'cursor': data?.banner_link ? 'pointer ': 'not-allowed' }">
                      <div class="top-banner-wrapper d-flex justify-content-center">
                          <img [src]="cfrnt_url + data.path" class="active imgLarge" alt="" loading="lazy" style="height: 362px;">
                      </div>
                  </a>
              </ng-template>
          </ng-container>

      </owl-carousel-o>
    </div>
  </ng-template>

</div>
<!-- <div class="container-fluid my-5 position-relative">
  <img src="../../assets/images/Square-T-skyblue.png" class="tata-ace-t-image" alt="T">
  Decorative Lines
  <div class="horizontal-line-tata"></div>
  <div class="vertical-line-tata"></div>
  <div class="bottom-horizontal-line-tata"></div>
  <div class="bottom-vertical-line-tata"></div>
  <div class="lower-lines-container"></div>
  <div class="middle-vertical"></div>
  <div class="container-custom">
    <div class="row">
      Text Section
      <div class="col-md-6">
        <h1 class="heading">Tata Ace Story</h1>
        <p class="content">
          The trusted Tata Ace range has empowered 23 million entrepreneurs while helping individuals achieve their success goals. One of India’s most desired Small Commercial Vehicles, the Tata Ace family offers variants across Diesel, Petrol, and CNG fuel options that suit different business needs. The Tata Ace family is specially designed to provide superior mileage, enhanced profits through increased productivity, and lower operational costs for more savings. Ensuring total peace of mind, the Tata Ace models offer a 2-year / 72,000 km warranty. Experience success with the power of Tata Ace Gold Diesel Plus.
        </p>
      </div>
      Image Section
      <div class="col-md-6 vehicles-images">
        <img src="../../assets/images/Group 2.png" alt="Tata Ace" class="img-fluid">
      </div>
    </div>
  </div>
</div>
 -->
<div class="category container-fluid " style="margin-top: 23px;">
  <div class="container-fluid" class="mt-2" id="backImg" >
      <div class="container">
      <div class="row col-12">
          <div class="col-md-3 col-sm-1 col-xs-1 col-lg-3 data-bind" *ngFor="let item of viewall">
              <div class="card mx-auto h-100">
                  <img [src]='item.path' class="card-img-top" alt="" loading="lazy">
                  <!-- <img src='https://d1t6fngbwb760h.cloudfront.net/prod/public_images/common/webp_banners/bus-banner.webp' class="card-img-top" alt="" loading="lazy"> -->

                  <div class="card-img-overlay">
                      <div class="content text-white">
                          <h2>Tata {{item.title}}</h2>
                          <p class="text-white text-ellipsis-3-line">{{item.sort_description}}</p>
                          <div class="d-block d-sm-block">
                              <a class="btn btn-outline-secondary text-white btn-sm btn-explore ps-xl-2 pe-xl-2 pt-xl-1 pb-xl-1" (click)="gotobrand(item)" >Know More
                                  <img [src]='environment1 + "assets/images/chevron-right.png"' />
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      </div>
  </div>
  <section class="container">
      <div class="plp-configure-wrapper pt-5 pb-5">
          <div class="row">
              <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <h1>Not sure which CV to buy?</h1>
                  <p class="mb-4">Let us help you find the perfect CV for your application</p>
                  <button class="btn btn-primary btn-grad-primary ps-5 pe-5 btn-height button-txt-desktop" [routerLink]="'/configurator-home'"
                      data-toggle="tooltip" data-placement="top" title="Click here to Build your own vehicle">Build
                      your own
                      vehicle</button>
              </div>
          </div>
      </div>
  </section>
  </div>
